module.exports = __webpack_public_path__ + "img/na-value-tool.499c3cd6.png";